import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="border-t border-white/10 bg-deck-deep py-12 text-sm text-slate-400">
      <div className="mx-auto grid max-w-6xl gap-8 px-4 sm:grid-cols-3">
        <div>
          <p className="font-display text-lg font-semibold text-slate-200">Pilot Mastery Academy</p>
          <p className="mt-2 max-w-xs">
            Evidence-based systems for wealth, decisions, and career transitions—spoken in flight-deck clarity.
          </p>
        </div>
        <div>
          <p className="font-medium text-slate-300">Legal</p>
          <ul className="mt-2 space-y-2">
            <li>
              <Link to="/privacy" className="hover:text-signal-sky">
                Privacy
              </Link>
            </li>
            <li>
              <Link to="/terms" className="hover:text-signal-sky">
                Terms
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <p className="font-medium text-slate-300">Contact</p>
          <p className="mt-2">
            Replace with your ESP-connected address before launch:{" "}
            <a className="text-signal-amber hover:underline" href="mailto:hello@pilotmastery.academy">
              hello@pilotmastery.academy
            </a>
          </p>
        </div>
      </div>
      <p className="mx-auto mt-10 max-w-6xl px-4 text-xs text-slate-600">
        © {new Date().getFullYear()} Pilot Mastery Academy. Educational positioning only where noted; not individualized
        tax, legal, or medical advice.
      </p>
    </footer>
  );
}
